var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 56,
    viewBox: "0 0 109 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.9625 32.3951V32.7847C60.9625 35.8755 60.9585 38.9675 60.9691 42.0583C60.9704 42.321 60.8949 42.4779 60.6644 42.6021C60.3611 42.7656 60.0802 42.9682 59.7795 43.1369C55.7592 45.3974 51.4196 46.0851 46.9091 45.3569C41.8502 44.5384 38.116 41.7576 35.8362 37.2182C34.2453 34.0516 33.934 30.6392 34.5036 27.1955C35.5448 20.9094 39.2989 16.8773 45.3897 14.9358C47.6297 14.2233 49.9518 14.1487 52.2832 14.3422C53.9325 14.4782 55.5644 14.7397 57.0918 15.3895C58.1369 15.8327 59.1318 16.3923 60.1836 16.9179C60.6578 16.2498 61.1771 15.5176 61.7069 14.7711C61.6023 14.6939 61.5201 14.6299 61.4367 14.571C59.9637 13.5329 58.3608 12.7433 56.6374 12.2111C53.3125 11.1848 49.9108 10.9181 46.4839 11.4829C40.356 12.4948 35.8362 15.8301 32.8848 21.1617C30.6766 25.152 30.3958 29.4835 31.1681 33.8973C31.8582 37.8418 33.8161 41.1091 36.8178 43.7801C39.2817 45.9727 42.1323 47.4213 45.3923 48.0593C48.8034 48.7274 52.2091 48.6045 55.5936 47.9011C58.7741 47.2409 61.597 45.8681 63.9496 43.618C64.1046 43.469 64.1735 43.3212 64.1721 43.1055C64.1655 39.6513 64.1682 36.1971 64.1682 32.7429V32.3951H60.9625ZM85.2197 12.1981V48.0149H88.4029V31.7989H106.046V29.1775H88.4029V14.8744H108.192V12.1981H85.2197ZM73.1428 48.0227H76.2836V12.1994H73.1428V48.0227Z",
    fill: "#000564"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8711 15.1101L3.38373 40.7062H18.5559",
    stroke: "#000564",
    strokeWidth: 1.54282
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6076 13.8094L24.824 2.82626L18.6076 13.8094Z",
    stroke: "#000564",
    strokeWidth: 1.54282
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6217 14.8792H3.38318L17.4505 39.7325",
    stroke: "#000564",
    strokeWidth: 1.54282
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8126 40.3718L24.8234 52.759L17.8126 40.3718Z",
    stroke: "#000564",
    strokeWidth: 1.54282
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4868 1.16409C25.8232 1.16409 26.9071 2.24799 26.9071 3.5844C26.9071 4.92203 25.8232 6.00593 24.4868 6.00593C23.1504 6.00593 22.0665 4.92203 22.0665 3.5844C22.0665 2.24799 23.1504 1.16409 24.4868 1.16409Z",
    fill: "#E6232D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4868 1.16409C25.8232 1.16409 26.9071 2.24799 26.9071 3.5844C26.9071 4.92203 25.8232 6.00593 24.4868 6.00593C23.1504 6.00593 22.0665 4.92203 22.0665 3.5844C22.0665 2.24799 23.1504 1.16409 24.4868 1.16409Z",
    stroke: "#E6232D",
    strokeWidth: 1.54282
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.03664 12.4611C4.37304 12.4611 5.45694 13.545 5.45694 14.8814C5.45694 16.219 4.37304 17.3029 3.03664 17.3029C1.70023 17.3029 0.616333 16.219 0.616333 14.8814C0.616333 13.545 1.70023 12.4611 3.03664 12.4611Z",
    fill: "#0A46F0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.03664 12.4611C4.37304 12.4611 5.45694 13.545 5.45694 14.8814C5.45694 16.219 4.37304 17.3029 3.03664 17.3029C1.70023 17.3029 0.616333 16.219 0.616333 14.8814C0.616333 13.545 1.70023 12.4611 3.03664 12.4611Z",
    stroke: "#0A46F0",
    strokeWidth: 1.54282
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5613 12.4611C18.8977 12.4611 19.9816 13.545 19.9816 14.8814C19.9816 16.219 18.8977 17.3029 17.5613 17.3029C16.2249 17.3029 15.141 16.219 15.141 14.8814C15.141 13.545 16.2249 12.4611 17.5613 12.4611Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5613 12.4611C18.8977 12.4611 19.9816 13.545 19.9816 14.8814C19.9816 16.219 18.8977 17.3029 17.5613 17.3029C16.2249 17.3029 15.141 16.219 15.141 14.8814C15.141 13.545 16.2249 12.4611 17.5613 12.4611Z",
    stroke: "#231F20",
    strokeWidth: 1.54282
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1059 25.3719C12.4423 25.3719 13.5262 26.4558 13.5262 27.7923C13.5262 29.1299 12.4423 30.2138 11.1059 30.2138C9.76945 30.2138 8.68555 29.1299 8.68555 27.7923C8.68555 26.4558 9.76945 25.3719 11.1059 25.3719Z",
    fill: "#FFDE17"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1059 25.3719C12.4423 25.3719 13.5262 26.4558 13.5262 27.7923C13.5262 29.1299 12.4423 30.2138 11.1059 30.2138C9.76945 30.2138 8.68555 29.1299 8.68555 27.7923C8.68555 26.4558 9.76945 25.3719 11.1059 25.3719Z",
    stroke: "#FFDE17",
    strokeWidth: 1.54282
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4868 49.5797C25.8232 49.5797 26.9071 50.6636 26.9071 52C26.9071 53.3376 25.8232 54.4215 24.4868 54.4215C23.1504 54.4215 22.0665 53.3376 22.0665 52C22.0665 50.6636 23.1504 49.5797 24.4868 49.5797Z",
    fill: "#FFDE17"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.03664 38.2827C4.37304 38.2827 5.45694 39.3666 5.45694 40.703C5.45694 42.0406 4.37304 43.1245 3.03664 43.1245C1.70023 43.1245 0.616333 42.0406 0.616333 40.703C0.616333 39.3666 1.70023 38.2827 3.03664 38.2827Z",
    fill: "#E6232D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4868 49.5797C25.8232 49.5797 26.9071 50.6636 26.9071 52C26.9071 53.3376 25.8232 54.4215 24.4868 54.4215C23.1504 54.4215 22.0665 53.3376 22.0665 52C22.0665 50.6636 23.1504 49.5797 24.4868 49.5797Z",
    stroke: "#FFDE17",
    strokeWidth: 1.54282
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.03664 38.2827C4.37304 38.2827 5.45694 39.3666 5.45694 40.703C5.45694 42.0406 4.37304 43.1245 3.03664 43.1245C1.70023 43.1245 0.616333 42.0406 0.616333 40.703C0.616333 39.3666 1.70023 38.2827 3.03664 38.2827Z",
    stroke: "#E6232D",
    strokeWidth: 1.54282
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5613 38.2827C18.8977 38.2827 19.9816 39.3666 19.9816 40.703C19.9816 42.0406 18.8977 43.1245 17.5613 43.1245C16.2249 43.1245 15.141 42.0406 15.141 40.703C15.141 39.3666 16.2249 38.2827 17.5613 38.2827Z",
    fill: "#0A46F0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5613 38.2827C18.8977 38.2827 19.9816 39.3666 19.9816 40.703C19.9816 42.0406 18.8977 43.1245 17.5613 43.1245C16.2249 43.1245 15.141 42.0406 15.141 40.703C15.141 39.3666 16.2249 38.2827 17.5613 38.2827Z",
    stroke: "#0A46F0",
    strokeWidth: 1.54282
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.3293,
    height: 55.4268,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.405df2b4.svg";
export { ForwardRef as ReactComponent };